import { FC } from 'react';

const TicketIcon: FC = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8711_4221)">
        <path
          d="M11.4782 11.4766C10.0226 11.4766 8.80531 12.4829 8.45783 13.8305L24 23.5703L39.5512 13.858C39.2132 12.4947 37.9883 11.4766 36.5217 11.4766H11.4782ZM8.34778 17.3217V33.3896C8.34778 35.116 9.75178 36.52 11.4782 36.52H36.5217C38.2481 36.52 39.6521 35.116 39.6521 33.3896V17.3553L24 27.1287L8.34778 17.3217Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8711_4221">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TicketIcon;
